export class PriceVersion {
    id: number;
    active: boolean;
}
